export enum MissingStatus {
    GOING = 'going',
    STAYING = 'staying',
    RETURNING = 'returning',
    COMPLETED = 'completed',
}
